import axios from 'axios';

interface Country {
    code: string;
    phone: string;
    countryName: string
}

// Module-level flag to prevent multiple simultaneous fetches
let isFetchingCountries = false;
let fetchCountriesPromise: Promise<Country[]> | null = null;


//to get country code from GeoLocation
// export const getCountryCode = async (countries: Country[], token: string) => {
//     try {
//         const ipResponse = await axios.get(`https://ipinfo.io/json?token=${token}`);
//         const userCountryCode = ipResponse.data.country;
//         const userCountry = countries.find((country) => country.code === userCountryCode);
//         return userCountry ? userCountry.phone : '';
//     } catch (error) {
//         console.error('Error fetching country code:', error);
//         return '';
//     }
// };
export const getCountryCode = async (countries: Country[], token: string) => {
    try {
        const ipResponse = await axios.get(`https://ipinfo.io/json?token=${token}`);
        const userCountryCode = ipResponse.data.country;
        const userCountry = countries.find((country) => country.code === userCountryCode);

        return userCountry ? { code: userCountry.code, name: userCountry.countryName } : { code: '', name: '' };
    } catch (error) {
        console.error('Error fetching country info:', error);
        return { code: '', name: '' };
    }
};

//to get all countries dial code and name 
export const getCountries = async (): Promise<Country[]> => {
    // If a fetch is already in progress, wait for it (prevents multiple simultaneous calls)
    if (fetchCountriesPromise) {
        return fetchCountriesPromise;
    }

    // If currently fetching, wait for the promise
    if (isFetchingCountries) {
        return fetchCountriesPromise || Promise.resolve([]);
    }

    // Fetch from API (always fetch fresh, no localStorage persistence)
    isFetchingCountries = true;

    fetchCountriesPromise = (async () => {
        try {
            const response = await axios.get('https://api.gain-intel.com/super-admin/country');
            const countries = response.data.countries || [];
            
            return countries;
        } catch (error) {
            console.error('Error fetching countries:', error);
            return [];
        } finally {
            isFetchingCountries = false;
            fetchCountriesPromise = null; // Clear promise when done
        }
    })();

    return fetchCountriesPromise;
};


export const sendMessage = async (formData: any) => {
    try {
        const response = await axios.post(
            'https://api.gain-intel.com/super-admin/demo/be9e4683-89f7-46c4-a0f8-afc8adf9491e',
            formData,
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );
        return { success: true };
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            const errorData = error.response.data;
            console.log('Error Data:', errorData);
            return { success: false, message: errorData.message || 'Failed to send message.' };
        } else {
            console.error('Error sending message:', error);
            return { success: false, message: 'An error occurred.' };
        }
    }
};


